import { roles } from '@transfeeradev/api-enums';
import ValidationsLayout from './Layout';
import NewValidationPage from './pages/NewValidationPage';
import ValidationHistoryPage from './pages/ValidationHistoryPage';
import loggedUser, { permissions } from '@/commons/resources/loggedUser';

export default {
  path: 'validacoes',
  component: ValidationsLayout,
  name: 'ContaCertaValidations',
  redirect: () => {
    return {
      name: loggedUser.isAnyAnalyst() ? 'ContaCertaValidationHistoryPage' : 'ContaCertaNewValidationPage'
    };
  },
  children: [
    {
      path: 'nova',
      name: 'ContaCertaNewValidationPage',
      component: NewValidationPage,
      meta: {
        forbidForRoles: [roles.appRoles.ANALYST, roles.appRoles.PAYMENTS_ANALYST, roles.appRoles.INFRACTIONS_OPERATOR],
        isAllowed() {
          return loggedUser.hasPermission(permissions.OperationContacertaValidation);
        }
      }
    },
    {
      path: 'historico',
      name: 'ContaCertaValidationHistoryPage',
      component: ValidationHistoryPage
    }
  ]
};
